export const ON_SWITCH_MENU = 'ON_SWITCH_MENU';
export const UNREAD_NOTIFICATION_FETCHED = 'UNREAD_NOTIFICATION_FETCHED';
export const READ_NOTIFICATION_FETCHED = 'READ_NOTIFICATION_FETCHED';
export const CLEAR_UNREAD_NOTIFICATION = 'CLEAR_UNREAD_NOTIFICATION';
export const NEW_NOTIFICATION = 'NEW_NOTIFICATION';
export const CLEAR_UNREAD_NOTIFICATIONS = 'CLEAR_UNREAD_NOTIFICATIONS';
export const SEEN_NOTIFICATION = 'NOTIFICATION_SEEN';
export const DELETE_UNREAD_NOTIFICATION = 'DELETE_UNREAD_NOTIFICATION';
export const DELETE_READ_NOTIFICATION = 'DELETE_READ_NOTIFICATION';
